import { useContext, useEffect, useState } from "react";
import { User } from "./Users";
import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "./Users";
import { Box, Button, Container, Grid, Snackbar, TextField } from "@mui/material";
import { selectAllOnFocus } from "./Common";

export const SignInPage = () => {
    const [user, setUser] = useState<Partial<User>>({});
    const navigate = useNavigate();
    const userContext = useContext(UserContext);
    const [snackbar, setSnackbar] = useState("");

    useEffect(() => {
        if ((userContext.user.username || "") !== "") {
            navigate("/home");
        }
    }, [userContext, navigate]);

    const signIn = async () => {
        const response = await fetch("/api/v1/user-auth/sign-in", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({"create_params": {"username": user.username, "token": ""}, "password": user.password})
        });
        const data = await response.json();
        if (data.result) {
            userContext.setUser(data.result || {})
            navigate("/home");
        } else if (data.error) {
            setSnackbar(data.error);
        }
    }

    return (
        <Box>
            <Grid component={Container} container spacing={2} sx={{ alignItems: "center" }}>
                <Grid size={{ xs: 12, md: 12 }}> <h1> Ekasi Prime Investments </h1> </Grid>
                <Grid container sx={{ justifyContent: "center" }} size={12}>
                    <TextField
                        id="username"
                        label="Username"
                        variant="outlined"
                        onFocus={selectAllOnFocus}
                        onChange={(e) => setUser(user => ({ ...user, username: e.target.value }))}
                        value={user.username || ""} />
                </Grid>
                <Grid container sx={{ justifyContent: "center" }} size={12}>
                    <TextField
                        id="password"
                        label="Password"
                        variant="outlined"
                        onFocus={selectAllOnFocus}
                        type="password"
                        onChange={(e) => setUser(user => ({ ...user, password: e.target.value }))}
                        onKeyUp={(e) => e.key === "Enter" ? signIn() : 0}
                        value={user.password || ""} />
                </Grid>
                <Grid container sx={{ justifyContent: "center" }} size={12}>
                    <Button variant="contained" onClick={signIn} > Log In </Button>
                </Grid>
            </Grid>
            <Snackbar
                open={snackbar !== ""}
                autoHideDuration={6000}
                onClose={(ev, reason) => setSnackbar("")}
                message={snackbar}/>
        </Box>
    )
}

export const SignOutPage = () => {
    const { signOutUsername } = useParams();
    const navigate = useNavigate();
    const userContext = useContext(UserContext);

    useEffect(() => {
        const fetchSignOut = async () => {
            if (signOutUsername) {
                await fetch("/api/v1/user-auth/sign-out", { method: "POST" });
                userContext.setUser({});
                navigate("/");
            }
        }
        fetchSignOut();
    }, [signOutUsername, navigate, userContext]);

    return (
        <></>  
    );
}